import React from 'react'
import '../styles/index.scss'
import EmbroideryErrorPage from './EmbroideryErrorPage'

function EmbroideryErrorContainer() {
    return (
        <div className='EmbroideryErrorContainer'>
            <EmbroideryErrorPage/>
        </div>
    )
}

export default EmbroideryErrorContainer